import MenuViewMode from './MenuViewMode';
/*
import PhysicalCameraManager from '../../PhysicalCameraManager';
import MenuCameraManager from '../../MenuCameraManager';
import GeofenceManager from '../../GeofenceManager';
import TaglockMarkerManager from '../../TaglockMarkerManager';
import PlayerSettings from '../../PlayerSettings';
import CameraObjectManager from '../../CameraObjectManager';
*/

// This represents the Live mode of the MenuView
/**
 * @class LiveMode
 * @description User is able to see his Live Cameras.Get activated when Live tab is clicked.
 * @function on_tab_selected() - Get called when user has clicked the tab. (called by MenuView).
 * @function on_player_hide() -  Get called when we want to hide the player. (called by PlayerContainer)
 * @function is_valid_camera() -  It works as filter for whcich camera to display in the menu view.Called by menuView.js
 * @function on_camera_selected() - When we select a camera this function is triggered.Plays the video and closes the side menu. Called by MenuView.js
 * 
 */
export default class LiveMode extends MenuViewMode
{
  constructor()
  {
    super('live');
  }

  on_tab_selected(menu_view)
  {
    if (PhysicalCameraManager.selected_camera) PhysicalCameraManager.selected_camera.show_player_on_zoom = false;
    menu_view.fill_menu(0);
    GeofenceManager.show_geofence();
    TaglockMarkerManager.remove_all_markers();
    PlayerSettings.set_live_mode();
    CameraObjectManager.set_live_mode();
  }

  is_valid_camera(physical_camera)
  {
    //return (physical_camera.stream_enable != 0 && (physical_camera.bodyworn !== 'yes' || physical_camera.is_live_stream_available()));
    return (physical_camera.bodyworn !== 'yes' || physical_camera.is_live_stream_available());
  }

  on_camera_selected(menu_view)
  {
    let camera = PhysicalCameraManager.selected_camera;
  
    //if (menu_view.app.mode_multi_camera)
    if (menu_view.app.menu_options_view.c2_launch_standalone)
    {
      console.dir(camera);

      let paremeters_to_encode = `start_mode=1&username=${camera.username}&password=${camera.password}&proxy_ip=${menu_view.app.multi_camera_manager.params.streamProxyAddr}`;

      let encodedData = btoa(paremeters_to_encode);

      //let url = `http://${camera.username}:${camera.password}@${PhysicalCameraManager.selected_camera.recordings_ip}/local/AXISTracker/standalone/index.html?${encodedData}`;
      let url = `http://${camera.username}:${camera.password}@${PhysicalCameraManager.selected_camera.recordings_ip}/local/AXISTracker/standalone/index.html`;
      console.log(`Opening camera url: ${url}`);
      window.open(url, '_blank').focus();

      return;
    }
    // Rewrite recording_id to undefined, to get the live streaming from the physical camera
    camera.stream.set_recording_data(undefined, 0, undefined);

    //let nga_camera = menu_view.app.mode_nga && camera.name != 'York3601';
    let nga_camera = false;

    //if (menu_view.app.mode_nga && camera.name != 'York3601')
    if (nga_camera)
    {
      camera.stream.start_streaming(menu_view.app.nga.player_view.play.bind(menu_view.app.nga.player_view));
    }
    else
    {
      if (camera.view_roi)
      {
        camera.stream.set_roi_view(camera.live_camera);
      }
      else
      {
        camera.stream.set_roi_view(undefined);
      }
      camera.stream.start_streaming(menu_view.app.player_view.play.bind(menu_view.app.player_view));
    }

    // Set the player view into live mode
    menu_view.app.player_view.set_live_mode();
    menu_view.app.player_view.extract_recording_view.hide_open_button();

    // Only use the show player on zoom function in certain situations
    // Don't use when we are already selected on a taglock
    if (!menu_view.app.mode_nga && !menu_view.app.camera_calibration_view.active && !menu_view.app.camera_location_calibration_view.active
      && !TaglockMarkerManager.is_taglock_selected())
    //if (true)
    {
      console.log(`[on_camera_selected] camera.name: ${camera.name} setting show_player_on_zoom`);
      
      PhysicalCameraManager.selected_camera.show_player_on_zoom = true;
      setTimeout(function() { 
        console.log(`[on_camera_selected] camera.name: ${camera.name} failed to show_player_on_zoom. Force show`);
     
        // If player has not opened on zoom for some reason force open player after a time
        if (PhysicalCameraManager.selected_camera?.show_player_on_zoom)
        {
          //menu_view.app.player_container.show_fade();
          menu_view.app.player_container.show(1, true);
          //menu_view.app.player_container.maximize();
          PhysicalCameraManager.selected_camera.show_player_on_zoom = false;
        }
      }.bind(this), 10000);

      // TEMP
      //menu_view.app.player_container.show();
    }
    else
    {
      console.log(`[on_camera_selected] camera.name: ${camera.name}`);
      if (nga_camera)
      {
        menu_view.app.nga.player_container.show();
      }
      else
      {
        //menu_view.app.player_container.show();
        menu_view.app.player_container.show(1, true);
        //menu_view.app.player_container.maximize();
      }

      PhysicalCameraManager.selected_camera.notify_player_active();
    }

    menu_view.close();

    if (PhysicalCameraManager.selected_camera.cam_type === 'phone')
    {
      PhysicalCameraManager.selected_camera.fly_on_valid_telemetry = true;
    }
  }

  on_tandem_selected(menu_view)
  {
    if (!PhysicalCameraManager.selected_camera_tandem)
    {
      return;
    }
    PhysicalCameraManager.selected_camera_tandem.plane_stream.set_recording_data(undefined, 0);
    PhysicalCameraManager.selected_camera_tandem.plane_stream.start_streaming(menu_view.app.player_view.tandem_plane_view_play.bind(PhysicalCameraManager, PhysicalCameraManager.selected_camera_tandem));
    
    menu_view.close();
  }
}
